import { UserService } from './../../base-services/user.service';
import { EventEmitter, Input, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { ChangeDetectorRef, Output } from '@angular/core';
import { Component } from '@angular/core';
import { MakeProvider, AbstractCustomControl } from '../abstract-custom-control';
import { NumberInputComponentV3 } from '../input/number-input/number-input-v3.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'yt-rebate-switch',
    templateUrl: './rebate-switch.component.html',
    providers: [ MakeProvider(RebateSwitchComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RebateSwitchComponent extends AbstractCustomControl<any>{
    constructor(protected changeDetectorRef: ChangeDetectorRef,
        protected userService: UserService,
        protected translateService: TranslateService){
        super(changeDetectorRef);
    }

    pValue: number = 0;
    vValue: number = 0;
    switchValue: number = 0;
    price: number = 0;

    @Output() OnChange = new EventEmitter<any>();
    @Input('Vrednost') set Price(value){
        this.price = value;
    }
    
    label1Translated: string; 
    @Input('Label1') set Label1Translated(value) {
        this.translateService.get([value])
        .subscribe(translate => {
            this.label1Translated = translate[value];
        })
    };

    label2Translated: string; 
    @Input('Label2') set Label2Translated(value) {
        this.translateService.get([value])
        .subscribe(translate => {
            this.label2Translated = translate[value];
        })
    };

    @ViewChild('txtRebatePerc', { static: true }) rebatePercControl: NumberInputComponentV3;
    @ViewChild('txtRebateValue', { static: true }) rebateValueControl: NumberInputComponentV3;
    @ViewChild('strelica', { static: true }) strelica: ElementRef;

    ngOnInit(){
        this.value = { Type: this.switchValue, PValue: this.pValue, VValue: this.vValue };
        //this.OnChange.emit(this.value);
    }

    toggleValue(){
        this.switchValue = this.switchValue == 0 ? 1 : 0;
        //this.pValue = this.switchValue == 0 ? this.pValue : this.vValue / this.price * 100;
        //this.vValue = this.switchValue == 1 ? this.vValue : this.price * (this.vValue / 100);
        // this.value["Type"] = this.switchValue;
        this.value = { Type: this.switchValue, PValue: this.pValue, VValue: this.vValue };
        this.OnChange.emit(this.value);
    }

    onInput(event, source){
        if(source == 'p'){
            this.pValue = parseFloat(event.target.value.replace(new RegExp('\\' + this.userService.GetThousandSeparator(), 'g'), '').replace(this.userService.GetDecimalSeparator(), '.'));
            this.vValue = this.price * this.pValue / 100;
            this.value = { Type: this.switchValue, PValue: this.pValue, VValue: this.vValue };
        }
        else if(source == 'v'){
            this.vValue = parseFloat(event.target.value.replace(new RegExp('\\' + this.userService.GetThousandSeparator(), 'g'), '').replace(this.userService.GetDecimalSeparator(), '.'));
            this.pValue = this.vValue / this.price * 100;
            this.value = { Type: this.switchValue, PValue: this.pValue, VValue: this.vValue };
        }


        //this.value = { Type: this.switchValue, PValue: parseFloat(event.target.value) };
        this.OnChange.emit(this.value);
    }

    onBlur(event){
        this.OnChange.emit(this.value);
    }

    writeValue(value){
        super.writeValue(value);
        if(value != null){
            this.switchValue = value.Type;
            //this.pValue = this.switchValue == 0 ? value.Value : 0;
            //this.vValue = this.switchValue == 1 ? value.Value : 0;
            this.pValue = value.PValue;
            this.vValue = value.VValue;
            this.value = { Type: this.switchValue, PValue: this.pValue, VValue: this.vValue };
            this.OnChange.emit(this.value);
        }
        else{
            this.pValue = 0;
            this.vValue = 0;
            this.value = { Type: this.switchValue, PValue: this.pValue, VValue: this.vValue };
        }
    }
    setDisabledState(isDisabled: boolean){
        super.setDisabledState(isDisabled);
        // this.rebatePercControl.inputControl.nativeElement.disabled = isDisabled;
        // this.rebateValueControl.inputControl.nativeElement.disabled = isDisabled;
        if (isDisabled==true) {
            this.rebatePercControl.setDisabledState(true);
            this.rebateValueControl.setDisabledState(true);
            this.rebatePercControl.inputControl.nativeElement.disabled = true;
            this.rebateValueControl.inputControl.nativeElement.disabled = true;
            this.strelica.nativeElement.disabled = true;
            
        } else {
            this.rebatePercControl.setDisabledState(this.value.Type==true);
            this.rebateValueControl.setDisabledState(this.value.Type==false);
            this.rebatePercControl.inputControl.nativeElement.disabled = this.value.Type==true;
            this.rebateValueControl.inputControl.nativeElement.disabled = this.value.Type==false;
            this.strelica.nativeElement.disabled = false;          
        }
       
        this.changeDetectorRef.markForCheck();
        //this.clearButton.nativeElement.disabled = isDisabled;
    }
}